module.exports = {"130609100":"安肃镇","130609101":"崔庄镇","130609102":"大因镇","130609103":"遂城镇","130609104":"高林村镇","130609105":"大王店镇","130609106":"漕河镇","130609200":"东史端乡","130609201":"留村乡","130609202":"正村乡","130609203":"户木乡","130609204":"瀑河乡","130609205":"东釜山乡","130609206":"义联庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130609.json
// module id = 141
// module chunks = 0